import JTBDIntro from './../components/sections/Tools/JTBD/JTBDIntro/JTBDIntro';
import JTBDRealLifeExamples from './../components/sections/Tools/JTBD/JTBDRealLifeExamples/JTBDRealLifeExamples';
import JTBDexercise from './../components/sections/Tools/JTBD/JTBDexercise/JTBDexercise';
import JTBMatter from './../components/sections/Tools/JTBD/JTBDMatter/JTBDMatter';
import JTBCTA from './../components/sections/Tools/JTBD/JTBCTA/JTBCTA';

const JobsToBeDonePage = () => {
  return (
    <>
      <JTBDIntro />
      <JTBDRealLifeExamples />
      <JTBMatter />
      <JTBDexercise />
      <JTBCTA />
    </>
  );
};

export default JobsToBeDonePage;